import { useState } from "react";
import i18n from "../../i18n";
import { Callout, HTMLSelect, Pre } from "@blueprintjs/core";

import { MultiParkSelect } from "../Structure/ParkSelector";

export default function ExportScriptEditor(props) {
  const [format, setFormat] = useState("excel");
  const [route, setRoute] = useState("/financial/exportreport");
  const [dates, setDates] = useState("Yesterday");
  const [language, setLanguage] = useState("fr");
  const [destination, setDestination] = useState("fr");
  const [parkFilter, setParkFilter] = useState("");

  const dates_models = {
    "Yesterday" : {
      start: "$(date --date=\"1 day ago\" +\"%Y-%m-%d\")T00:00:00",
      end: "$(date +\"%Y-%m-%d\")T00:00:00",
    },
    "Last month" : {
      start: "$(date --date=\"1 month ago\" +\"%Y-%m\")-01T00:00:00",
      end: "$(date +\"%Y-%m\")-01T00:00:00",
    },
    "Last year" : {
      start: "$(date --date=\"1 year ago\" +\"%Y\")-01-01T00:00:00",
      end: "$(date +\"%Y\")-01-01T00:00:00"
    }
  }
  
  const need_permissions = {
    "/financial/exportreport" : i18n.t("access to financial report"),
    "/activity/exportreport" : i18n.t("access to activity report"),
    "/supervision/history/export" : i18n.t("access supervision"),
  }

  const file_name = {
    "/financial/exportreport" : "WLX_financial_",
    "/activity/exportreport" : "WLX_activity_",
    "/supervision/history/export" : "WLX_events_",
  }

  const extensions = {
    "excel" : "xlsx",
    "csv" : "csv",
    "html" : "html"
  }

  let destination_file;
  switch (destination) {
    case "scp": 
    case "sftp": 
      destination_file = (<>DST="/tmp/"<br/>
      FILENAME="{file_name[route]}{"${"}FROM//:{"}"}_{"${"}TO//:{"}"}.{extensions[format]}"<br/></>);
      break;

    case "Local file":
    default:
      destination_file = (<>DST="/home/largo/exports/"<br/>
      FILENAME={file_name[route]}{"${"}FROM//:{"}"}_{"${"}TO//:{"}"}.{extensions[format]}<br/></>);
      break;
  }

  let transfer_cmd;
  switch (destination) {
    case "scp": 
      transfer_cmd = <><br/>USER="user"<br/>HOST="1.2.3.4"<br/>DST_PATH=/home/toto/exports/<br/>scp "$DST$FILENAME" $USER@$HOST:$DST_PATH"</>;
      break;
    case "sftp": 
      transfer_cmd = <><br/>USER="user"<br/>HOST="1.2.3.4"<br/>sftp $USER@$HOST {"<<"}EOF<br/>
      {"  "}put "$DST$FILENAME" /remote/path/<br/>
      EOF
      </>;
      break;

    case "Local file":
    default:
      transfer_cmd = "";
      break;
  }

  let parks_filter=[];
  for(const parkpk of parkFilter){
    console.log("--data-urlencode \"parks="+parkpk+"\"")
    parks_filter.push(<>{"  "}--data-urlencode "parks={parkpk}" \<br/></>);
  }
  

  return (
  <Callout icon="open-application" title="generate export script">
    <div className="flexbox-left">
      <HTMLSelect
        options={[
          { label: "Excel", value: "excel" },
          { label: "CSV", value: "csv" },
          { label: "HTML", value: "html" }
        ]}
        onChange={(s) => setFormat(s.target.value)}
      />

      <HTMLSelect
        options={[
          { label: "Financial report", value: "/financial/exportreport" },
          { label: "Activity report", value: "/activity/exportreport" },
          { label: "Event history", value: "/supervision/history/export" }
        ]}
        onChange={(s) => setRoute(s.target.value)}
      />

      <HTMLSelect
        options={[
          { label: "Yesterday", value: "Yesterday" },
          { label: "Last month", value: "Last month" },
          { label: "Last year", value: "Last year" }
        ]}
        onChange={(s) => setDates(s.target.value)}
      />

      <HTMLSelect
        options={[
          { label: "French", value: "fr" },
          { label: "English", value: "en" }
        ]}
        onChange={(s) => setLanguage(s.target.value)}
      />

      <HTMLSelect
        options={[
          { label: "Local file", value: "local" },
          { label: "scp server", value: "scp" },
          { label: "sftp server", value: "sftp" }
        ]}
        onChange={(s) => setDestination(s.target.value)}
      />

      <div style={{maxWidth:"30px"}}>
        <MultiParkSelect
          onSelect={(parks) => {
            setParkFilter(parks);
          }}
        />
      </div>
    </div>
    
    <Callout>This script can be called from the server by a cron task to generate report and store them on a shared folder. You can also send this file via scp or sftp at the end of this script</Callout>
      API key will need permission <b>{need_permissions[route]}</b>
      <Pre>
#!/bin/bash<br/>
<br/>
APIKEY="REPLACE WITH NEWLY CREATED API KEY"<br/>
<br/>
FROM="{dates_models[dates].start}"<br/>
TO="{dates_models[dates].end}"<br/>
<br/>
{destination_file}
<br/>
# FORMAT = excel | csv | html<br/>
FORMAT="{format}"<br/>
<br/>
# LANGUAGE= fr | en<br/>
LANGUAGE="{language}"<br/>
<br/>
mkdir -p "$DST"<br/>
<br/>
curl --get -H "x-api-key: $APIKEY" --output "$DST$FILENAME" \<br/>
{"  "}--data-urlencode "fr=$FROM" \<br/>
{"  "}--data-urlencode "to=$TO" \<br/>
{"  "}--data-urlencode "format=$FORMAT" \<br/>
{"  "}--data-urlencode "lg=$LANGUAGE" \<br/>
{parks_filter}
{"  "}{window.config.backend.http_route}{route}<br/>
{transfer_cmd}
      </Pre>
    </Callout>);
}